module.exports = __webpack_public_path__ + "static/img/complain.e453827.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/complain.jpg
// module id = oMmT
// module chunks = 1